<template>
  <div>
    <div
      class="tag-input-container d-flex"
      :class="inputClass"
      @keydown.space.prevent="onSpacePress"
      @keydown.enter.prevent="addNew"
      @keydown.delete.stop="removeLastTag"
    >
      <el-input v-model="newTag" :placeholder="placeholder" @change="addNew">
        <el-button slot="append" icon="el-icon-search" @click="tagChange" />
      </el-input>
    </div>
    <div class="tag-container">
      <el-tag
        v-for="(tag, idx) in innerTags"
        v-bind="$attrs"
        size="small"
        :key="tag"
        :disable-transitions="false"
        closable
        @close="remove(idx)"
      >
        {{ tag }}
      </el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagInput',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      newTag: '',
      innerTags: [...this.value],
    }
  },
  watch: {
    value() {
      this.innerTags = [...this.value]
    },
  },
  methods: {
    // element.common.js prevents space on el-menu children
    onSpacePress() {
      this.newTag += ' '
    },
    addNew() {
      let addSuccess = false
      if (this.newTag.includes(',')) {
        this.newTag.split(',').forEach((item) => {
          if (this.addTag(item)) {
            addSuccess = true
          }
        })
      } else {
        if (this.addTag(this.newTag)) {
          addSuccess = true
        }
      }
      if (addSuccess) {
        this.tagChange()
        this.newTag = ''
      }
    },
    addTag(tag) {
      tag = tag.trim()
      if (tag && !this.innerTags.includes(tag)) {
        this.innerTags.push(tag)
        return true
      }
      return false
    },
    remove(index) {
      this.innerTags.splice(index, 1)
      this.tagChange()
    },
    removeLastTag() {
      if (this.newTag) {
        return
      }
      this.innerTags.pop()
      this.tagChange()
    },
    tagChange() {
      this.$emit('input', this.innerTags)
    },
  },
}
</script>

<style lang="scss" scoped>
.el-tag {
  margin: 0 10px 10px 0;
}
.tag-container {
  min-height: 34px;
  height: fit-content;
}
.tag-input {
  height: 40px;
  width: 100%;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid $border-color-base;
  overflow: hidden;
  padding: 0 0 0 10px;
  outline: none;
}
</style>
